'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = function (ComposedComponent) {
  var _desc, _value, _class;

  return _class = function (_React$Component) {
    (0, _inherits3.default)(WithSize, _React$Component);

    function WithSize(props) {
      (0, _classCallCheck3.default)(this, WithSize);

      var _this = (0, _possibleConstructorReturn3.default)(this, (WithSize.__proto__ || Object.getPrototypeOf(WithSize)).call(this, props));

      _this.state = _this.calculateSize();
      _this.debouncedHandle = (0, _throttle2.default)(_this.setNewState, 50);
      return _this;
    }

    (0, _createClass3.default)(WithSize, [{
      key: 'calculateSize',
      value: function calculateSize() {
        var _window = window,
            innerHeight = _window.innerHeight,
            innerWidth = _window.innerWidth;

        return { innerHeight: innerHeight, innerWidth: innerWidth };
      }
    }, {
      key: 'setNewState',
      value: function setNewState() {
        this.setState(this.calculateSize());
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        window.addEventListener('resize', this.debouncedHandle);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('resize', this.debouncedHandle);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(ComposedComponent, (0, _extends3.default)({}, this.props, this.state));
      }
    }]);
    return WithSize;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'setNewState', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'setNewState'), _class.prototype)), _class;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _throttle = require('lodash/throttle');

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/decorators/withSize.js
// module id = 410
// module chunks = 85